import { useInternalFeatureAccess } from "@-/dev.improve.haniverse.lib.admin.access";
import { useAuthSession } from "@-/dev.improve.haniverse.lib.auth.client";
import { useEffect } from "react";
import { startRecentDebugLogs } from "#recent-debug-logs";

/** Lightweight log capture is independent of the opt-in performance recorder. */
export function useRecentDebugLogRecorder(): void {
  const { user } = useAuthSession();
  const enabled = useInternalFeatureAccess();
  useEffect(() => {
    if (enabled) {
      return startRecentDebugLogs();
    }
  }, [enabled, user?.id]);
}
